/** Joins truthy class names. */
export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

/** Joins ids for aria-describedby; returns undefined when empty. */
export function describedBy(...ids: (string | false | null | undefined)[]): string | undefined {
  const value = ids.filter(Boolean).join(' ');
  return value || undefined;
}

export type InputWidth = '2' | '3' | '4' | '5' | '10' | '20' | '30';
export type FluidWidth = 'full' | 'three-quarters' | 'two-thirds' | 'one-half' | 'one-third' | 'one-quarter';

/** ID-SK/GOV.UK width class: fixed character widths (govuk-input--width-N) or fluid widths (govuk-!-width-*). */
export function widthClass(width: InputWidth | FluidWidth | undefined, kind: 'input' | 'select' = 'input'): string | undefined {
  if (!width) return undefined;
  if (/^\d+$/.test(width)) return kind === 'input' ? `govuk-input--width-${width}` : undefined;
  return `govuk-!-width-${width}`;
}
